import PropTypes from 'prop-types';
import { Rating } from '@codex/basics';
import styled from 'styled-components';
import { getTranslation } from '../../translations/translations';

const WrapperReevooPlaceholder = styled.div`
  @media ${({ theme }) => theme.breakpoints.mobile} {
    font-size: 12px;
    text-align: center;
  }
`;

const ProductItemReviewInfo = ({ review }) => (
  <WrapperReevooPlaceholder className={'reevoo-placeholder'}>
    {review?.reviewCount && review.reviewCount > 0 ? (
      <Rating maxCount={5} ratingCount={review.reviewCount} ratingValue={review.score} />
    ) : (
      <small>{getTranslation('noReviewsTranslation')}</small>
    )}
  </WrapperReevooPlaceholder>
);

ProductItemReviewInfo.propTypes = {
  review: PropTypes.shape({
    reviewCount: PropTypes.number.isRequired,
    score: PropTypes.number
  })
};

ProductItemReviewInfo.defaultProps = {
  review: undefined
};

export default ProductItemReviewInfo;
